import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {css} from "@emotion/react";
import {Col, Container, Row} from "@pg-design/grid";
import {mb} from "@pg-design/helpers-css";

import {withGTM} from "../../../components/hoc/withGTM";
import {SimpleContainer} from "../../../components/layout/SimpleContainer";
import {Faq} from "../../../components/views/Faq";
import {pageviewAlgolyticsHit} from "../../tracking/algolytics/pageview_hits";
import {usePageview} from "../../tracking/use_pageview";
import {ViewType} from "../../tracking/view_type";
import {AnalyticalPlatformReasons} from "../components/AnalyticalPlatformReasons";
import {BigDataAccessPlans} from "../components/BigDataAccessPlans";
import {BigDataHowItWorks} from "../components/BigDataHowItWorks";
import {BigDataLandingContact} from "../components/BigDataLandingContact";
import {Hero, LANDING_BIG_DATA_CONTACT_SECTION_ID} from "../components/hero/Hero";
import {LandingMicroCopyLine} from "../components/landingMicroCopy";
import {ReliableData} from "../components/ReliableData";

export const AnalyticalPlatformLanding = withGTM(() => {
    const {t} = useTranslation();

    usePageview(() => {
        pageviewAlgolyticsHit({viewType: ViewType.LANDING});
    });

    // Scroll the view to the top of the window after leaving the landing page
    useEffect(() => {
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    return (
        <SimpleContainer>
            <Hero />

            <AnalyticalPlatformReasons />

            <ReliableData />

            <BigDataHowItWorks />

            <BigDataAccessPlans />

            <BigDataLandingContact id={LANDING_BIG_DATA_CONTACT_SECTION_ID} />

            <Faq embedded />

            <Container>
                <Row>
                    <Col css={faqMicroCopyCol} mdOffset={1} md={10} lgOffset={2} lg={12}>
                        <LandingMicroCopyLine>{t("landing.analyticalPlatformFaq.ctaMicroCopy")}</LandingMicroCopyLine>
                    </Col>
                </Row>
            </Container>
        </SimpleContainer>
    );
});

const faqMicroCopyCol = css`
    ${mb(6)};
`;
